'use client';

import Link from 'next/link';
import { Scale, Building2, BarChart3, BookOpen } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { getLocaleFromPathname, toFrenchProfessionSlug } from '@/lib/i18n';

const stats = [
  {
    icon: Scale,
    value: 'Legal',
    slug: 'legal',
    label: 'AI Tools Audited',
    sublabel: 'Litigation · Drafting · Research',
    color: 'var(--primary)',
  },
  {
    icon: Building2,
    value: 'Real Estate',
    slug: 'real-estate',
    label: 'Workflow Coverage',
    sublabel: 'Brokerage · Valuation · CRM',
    color: 'var(--info)',
  },
  {
    icon: BarChart3,
    value: 'Finance',
    slug: 'finance',
    label: 'Risk-Aware Tools',
    sublabel: 'Advisory · Compliance · Controls',
    color: 'var(--success)',
  },
  {
    icon: BookOpen,
    value: 'Education',
    slug: 'education',
    label: 'Institutional AI',
    sublabel: 'Curriculum · Student Support',
    color: 'var(--warning)',
  },
];

export default function TrustBand() {
  const pathname = usePathname();
  const locale = getLocaleFromPathname(pathname);
  const localePrefix = locale === 'fr' ? '/fr' : '';

  return (
    <div className="trust-band-wrapper" aria-label="Platform coverage">
      {/* Bleed circles – purely decorative */}
      <span className="trust-circle trust-circle--tl" aria-hidden="true" />
      <span className="trust-circle trust-circle--tr" aria-hidden="true" />
      <span className="trust-circle trust-circle--br" aria-hidden="true" />

      <div className="trust-band-inner">
        {stats.map(({ icon: Icon, value, slug, label, sublabel, color }) => (
          <Link 
            key={value} 
            href={`${localePrefix}/${locale === 'fr' ? toFrenchProfessionSlug(slug) : slug}`}
            className="trust-stat group/stat"
          >
            <span
              className="trust-stat__icon-wrap transition-transform group-hover/stat:scale-110"
              style={{ '--stat-color': color } as React.CSSProperties}
            >
              <Icon className="trust-stat__icon" aria-hidden="true" />
            </span>
            <span className="trust-stat__text">
              <strong className="trust-stat__value transition-colors group-hover/stat:brightness-125" style={{ color }}>{value}</strong>
              <span className="trust-stat__label">{label}</span>
              <span className="trust-stat__sub">{sublabel}</span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
